import { render, staticRenderFns } from "./validWarn.vue?vue&type=template&id=1d467922&scoped=true&"
import script from "./validWarn.vue?vue&type=script&lang=js&"
export * from "./validWarn.vue?vue&type=script&lang=js&"
import style0 from "./validWarn.vue?vue&type=style&index=0&id=1d467922&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d467922",
  null
  
)

export default component.exports